import { Grid } from '@mui/material';
import './employerStyle.scss'
import { ReactComponent as LoginBg } from '../../assets/images/sign-in-bg.svg';
//CONTACT US FUNCTION 
const ContactUsComponent = () => {

    return (
        <div className="SinginFormPage">

            <Grid container spacing={0}>
                <Grid item xs={12} sm={6}>
                    <div className="SinginFormLeft" style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                        <LoginBg className="SinginFormBgImg BannerSVG" />
                    </div>
                </Grid>

                <Grid item xs={12} sm={5}>
                    <div className="SinginFormRight">
                        <a>
                            <img src={require('../../assets/images/Logo Blue TM.png')} className="SinginFormLogo" alt="" />
                        </a>
                        <div className="SinginFormTitleContainer" style={{ paddingTop: '30px', paddingBottom: '10px' }}>
                            <span className="SinginFormTitle" style={{ marginBottom: '0' }}>
                                {'Contact Us'}
                            </span>

                        </div>
                        <div >
                            {/* <div className="contact-comunication">
                                <h2> Address</h2>
                                <p>TEAMBLUE PART TIME JOBS PRIVATE LIMITED</p>
                                <p>First Floor, No.11, Parasakthi Nagar,
                                    Veli Semmendalem, Cuddalore, Cuddalore, Tamil Nadu,
                                    607001</p>
                            </div>
                            <div className="contact-phone">
                                <h2> Phone</h2>
                                <p>+91 9361669498</p>
                            </div> */}
                            <div className="contact-email">
                                <h2> Email</h2>
                                <p>pr@parttimer.in</p>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <img src={require('../../assets/images/geo.png')} className="SignInGeoTop" alt="" />
            <img src={require('../../assets/images/geo1.png')} className="SignInGeoBottom" alt="" />
        </div>
    );
}

export default ContactUsComponent;